import React, { useEffect, useState } from "react";
import Menu from "../../Components/Menu";
import Footer from "../../Components/Footer";
import { Container } from "./styles";
import NoticeBlock from "../../Components/NoticeBlock";

import { db } from "../../server/";

export default function Blog() {
	document.title = "DNA for performance - Blog";

	const [noticeList, setNoticeList] = useState([]);
	const [pageQtdContent, setPageQtdContent] = useState(5);
	const [endPage, setEndPage] = useState(false);

	useEffect(() => {
		const dbRef = db.collection("noticias");

		dbRef.get().then((snapshot) => {
			if (!snapshot.empty) {
				const notices = snapshot.docs.slice(0, pageQtdContent).map((doc) => ({
					id: doc.id,
					...doc.data(),
				}));

				setNoticeList(notices);
				if (notices.length < pageQtdContent) {
					setEndPage(true);
				}
			}
		});
	}, [pageQtdContent]);

	return (
		<>
			<Menu />
			<Container>
				<div className="title-wrapper">
					<h1>Fique por dentro das novidades!</h1>
				</div>

				<div className="notice_list-wrapper">
					{noticeList.length === 0 ? (
						<p>Nenhuma Notícia por aqui ainda, volte amanhã!</p>
					) : (
						<>
							<ul>
								{noticeList.map((e) => (
									<li key={e.id}>
										<NoticeBlock
											title={e.title}
											shortDesc={e.shortDesc}
											cover={e.coverURL}
											id={e.id}
										/>
									</li>
								))}
							</ul>
							{endPage === true ? (
								<></>
							) : (
								<div className="loadmore-button_wrapper">
									<button
										className="loadmore-button"
										onClick={() => setPageQtdContent((prev) => prev + 5)}>
										Carregar mais
									</button>
								</div>
							)}
						</>
					)}
				</div>
			</Container>
			<Footer />
		</>
	);
}
